import { Spinner } from '@heroui/spinner'
import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'

import { getFormControllerFindFormForUserClientQueryOptions } from '@/api/form/form'
import { getVerificationControllerFindVerificatonsByTokenQueryOptions } from '@/api/verification/verification'
import { queryClient } from '@/shared/lib/query'
import { FullPageWrapper } from '@/shared/ui'
import { VerificationLevel } from '@/widgets/verification-level'

const searchSchemaValidation = z.object({
  verificationId: z.string().min(1),
})

export const Route = createFileRoute('/_public-links/verification/select-form/')({
  validateSearch: (search) => searchSchemaValidation.parse(search),
  loader: async () => {
    const verificationData = await queryClient.ensureQueryData(
      getVerificationControllerFindVerificatonsByTokenQueryOptions(),
    )

    const formIds = [verificationData.verification?.formId, verificationData.otherFormId].filter(Boolean)

    await Promise.all(
      formIds.map((formId) =>
        queryClient.prefetchQuery(getFormControllerFindFormForUserClientQueryOptions(formId!)),
      ),
    )
  },
  pendingComponent: () => (
    <FullPageWrapper>
      <div className="flex w-full flex-col items-center justify-center">
        <Spinner size="lg" />
      </div>
    </FullPageWrapper>
  ),
  pendingMs: 0,
  component: RouteComponent,
})

export const VerificationLevelSelectFormRoute = Route

function RouteComponent() {
  return <VerificationLevel />
}
